module.exports = __webpack_public_path__ + "static/media/FEDERAL.42c4dc32.svg";